<template>
  <section class="tab-body">
    <div class="row">
      <div class="col-md">
        <p class="tab-description">
          <span class="bold-font">Guest List</span><br>
          People who have accepted this pass.<br>
          <small>* Total No. of Guests: {{ guestsCount }}</small><br>
        </p>
      </div>
      <div class="col-md text-center">
        <button @click="exportGuestsToPDF()" v-if="hasAccepted"
          class="btn btn-primary btn-export">
          Export Guests to PDF
        </button>
      </div>
    </div>

    <accepted-list-view
      :includedPassDetails="includedPassDetails"
      :acceptedList="acceptedList"
      :hasAccepted="hasAccepted"
      :isShowAcceptedModal="isShowAcceptedModal"
      :acceptedItem="acceptedItem"
      :convertEpochTime="convertEpochTime"
      :showAcceptedModal="showAcceptedModal"
      :closeAcceptedModal="closeAcceptedModal"
      :sendMessage="sendMessage" />
  </section>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'

import AcceptedListView from '@/components/listview/AcceptedListView'

export default {
  components: {
    'accepted-list-view': AcceptedListView,
  },
  data() {
    return {
      isShowAcceptedModal: false,
      acceptedItem: {}
    }
  },
  props: {
    passName: String,
    includedPassDetails: Array,
    acceptedList: Array,
    hasAccepted: Boolean,
    convertEpochTime: Function
  },
  computed: {
    guestsCount() {
      return this.acceptedList.length
    }
  },
  mounted() {

  },
  methods: {
    closeAcceptedModal() {
      this.isShowAcceptedModal = false
    },
    showAcceptedModal(data) {
      this.isShowAcceptedModal = true
      this.acceptedItem = data
    },
    sendMessage(data) {
      console.log('do nothing yet - but toDoSendEmail???')
    },
    exportGuestsToPDF() {
      let pdfName = this.passName
      const doc = new jsPDF()
      doc.setFontSize(22)
      doc.text(20, 20, `List of Names for:\n${this.passName}`)
      doc.setFontSize(12)
      this.acceptedList.map((i, ix) => {
        const y = 40 + (ix * 7)
        doc.text(i.individual_details.full_name, 20, y)
      })
      doc.save('Guests-' + pdfName + '.pdf')
    },
  }
}
</script>


<style scoped>
small{
  color:#547181;
}

.bold-font {
  font-weight: bold;
}

.tab-body {
  background-color: #FAFAFA;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  /*border-top: 1px solid #FAFAFA;*/
}

.tab-description {
  padding-top: 40px;
  padding-left: 25px;
  margin-bottom: 40px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/tabview/GuestsTab.vue